<template>
  <div class="fl">
    <img :src="img_404" alt="" /><br />
    <a href="/">返回首页</a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img_404: require("../../assets/images/404.jpg"),
    };
  },
};
</script>

<style>
.fl {
  text-align: center;
}
</style>
